import React from 'react';
import MapToolbar from './MapToolbar';
import styled from 'styled-components';
import ZoomToolbar from './ZoomToolbar';
import MeasureOptions from './MeasureOptions';
import MetaDataModal from "components/MetadataModal";
import ObliquesModal from "components/ObliquesModal";
import { useSelector, useDispatch } from 'react-redux';
import RequestInfoModal from "components/RequestInfoModal";

const Wrapper = styled.div`
  position: absolute;
  bottom: 3rem;
  left: 3rem;
  display: flex;
  width: calc(100% - 15rem);
  justify-content: space-between;
  align-items: center;
`;

const Toolbar = (props) => {
  const showMeasureOptions = useSelector(state => state.settings.showMeasureOptions);
  const DatePaginatorOption = useSelector(state => state.settings.showDatePaginatorOption);
  const showMetadataModal = useSelector(state => state.settings.showMetadataModal);
  const showReqInfoModal = useSelector(state => state.settings.showReqInfoModal);
  const showObliquesModal = useSelector(state => state.settings.showObliquesModal);
  const assetMetaData = useSelector(state => state.asset.assetMetaData);
  const reqInfoMetadata = useSelector(state => state.asset.reqInfoMetadata);
  const obliqueAssets = useSelector(state => state.asset.obliqueAssets);
  const dispatch = useDispatch();

  const handleToggleModal = () => {
    dispatch({ type: 'TOGGLE_METADATA_MODAL', show: !showMetadataModal });
  };

  const handleToggleReqInfoModal = () => {
    dispatch({ type: 'TOGGLE_REQINFO_MODAL', show: !showReqInfoModal });
  }

  const handleToggleObliqueModal = () => {
    dispatch({ type: 'TOGGLE_OBLIQUE_MODAL', show: !showObliquesModal });
  }

  return (
    <>
      {
        showMeasureOptions && <MeasureOptions />
      }
      <Wrapper>
        <MapToolbar missionDates={props.missionDates} />
        {DatePaginatorOption ? <p></p> : <p></p>}
        <ZoomToolbar />
        {showMetadataModal && <MetaDataModal info={assetMetaData} handleToggleModal={handleToggleModal} />}
        {showReqInfoModal && <RequestInfoModal info={reqInfoMetadata} handleToggleModal={handleToggleReqInfoModal} />}
        {showObliquesModal && <ObliquesModal info={obliqueAssets} handleToggleModal={handleToggleObliqueModal} />}
      </Wrapper>
    </>
  )
}

export default Toolbar;